export const BORROWER_DOCUMENT_TYPE = {
  DRAW_SUMMARY: "DRAW_SUMMARY",
  INVOICE: "INVOICE",
  LIEN_WAIVER_OR_PAY_APPLICATION: "LIEN_WAIVER_OR_PAY_APPLICATION",
  OTHER: "OTHER",
};
